

const axios = require('axios');


module.exports = {
	
	get: function(route, token) {
		return call('get', route, token);
	},

	post: function(route, payload, token) {
		// console.log("payload in hooks:", payload);
		return call('post', route, token, payload);
	},

	put: function(route, payload, token) {
		// console.log("route,payload,token:", route, payload, token);
		return call('put', route, token, payload);
	},

	// delete: function(route, payload, token) {
	// 	return call('delete', route+"/"+payload, token);
	// },
	delete: function(route, payload, token) {
		if (payload) route = route + "/" + payload;
		return call('delete', route, token);
	},

	head: function(route, payload, token) {
		if (payload) route = route + "/" + payload;
		return call('head', route, token);
	}

}



async function call(method, route, token, payload ) {

	// console.log("no token?", token)

	// console.log("ROUTE:", route);

	try {

		const config = {
			method,
			url: "/user"+route,
			headers: {
				Authorization: "Bearer "+token,
				'Cache-Control': 'no-cache',
			}
		}

		// console.log("config:", config);

		// console.log("hooks url:", config.url);

		// console.log("what is payload before we send:", payload);

		if (payload) config.data = payload;
		// console.log("config:", config);

		const result = await axios(config);
		// console.log("result:", result);

		// console.log("after");

		// console.log("what is status, data:", result.status, result.data);
		if (method == "head") return result.status;

		return result.data;

	} catch(err) {

		console.error('\txx error in hooks:', route, payload);
		console.error(err);
		throw err

	}
}



